<template>

  <div>

    <edit-pane
        ref="step4"
        @save="onSave"
        @cancel="onCancel"
        @edit="onEdit" />

        <el-row :gutter="8">

         <el-form label-position="top" >
           <el-col :span="12">

            <el-form-item>
            <select-action-status v-model="step4.status" :disabled="dis" />
          </el-form-item>
        </el-col>

          <el-col :span="12">
         <el-form-item>
           <select-priority v-model="step4.priority" :disabled="dis"/>
         </el-form-item>
       </el-col>

      </el-form>
    </el-row>

  <el-tabs>
     <el-tab-pane
      border-card
      v-for="(ref, index) in step4.actions" :label="ref.name + ' Renewal'"
       :name="ref.name"
       :key="ref.id">

       <el-form label-position="top" >

         <el-row :gutter="8">

           <el-col :xs="24" :sm="12" :md="12" :lg="6">

          <el-form-item :label="ref.name + ' Ref'">
            <el-input v-model="ref.ref"
            :id="'renref' + index"
            :placeholder="ref.name + ' Ref.'"
            :disabled="dis" />
          </el-form-item>

          <el-form-item :label="ref.name + ' Amount'">
            <text-input
            type="number"
            :id="'renamnt' + index"
            v-model="ref.fee" placeholder="Amount"
            :disabled="dis" />
          </el-form-item>

        </el-col>

          <el-col :xs="24" :sm="12" :md="12" :lg="6">

          <el-form-item :label="ref.name + ' Cheque #'">
            <el-input
            :id="'renchq' + index"
             v-model="ref.chqNo" placeholder="Chq No"
             :disabled="dis" />
          </el-form-item>

          <el-form-item  :label="ref.name + ' Chg. Received'">
            <el-date-picker
            :id="'renrecv' + index"
            :format="dateFormat"
            v-model="ref.chqDate" placeholder="Chq Received"
            :disabled="dis" />
          </el-form-item>

        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8">

          <el-form-item :label="ref.name + ' Submitted'">
            <el-date-picker :format="dateFormat"
            :id="'rensub' + index"
            v-model="ref.submittedOn"
            placeholder="Submitted"
            :disabled="dis" />
          </el-form-item>

          <el-form-item :label="ref.name + ' Status'">
            <el-select :format="dateFormat"
            :id="'renstat' + index"
            v-model="ref.status"
            placeholder="Status"
            :disabled="dis">
            <el-option
            v-for="st in status"
            :label="st.type" :value="st.type" :key="st.type" />
          </el-select>
        </el-form-item>

        <el-form-item :label="ref.name + ' Decision'">
          <el-date-picker :format="dateFormat"
          :id="'rensd' + index"
          v-model="ref.statusDate"
          placeholder="Status Date"
          :disabled="dis" />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
        <el-col :span="24">

        <html-input
          :label="ref.name + ' Remarks'"
          :id="'renrem' + index"
          v-model="ref.remarks"
          placeholder="Remarks"
          :disabled="dis" />

        </el-col>
      </el-row>

        </el-form>


      </el-tab-pane>

      </el-tabs>

      <files-panel
        v-if="rowData.id"
        type="site"
        :id="rowData.site_id"
        process="progress"
        :process-id="rowData.id"
        :disabled="dis"
        :max-files="20"
         />



</edit-pane>

</div>
</template>


<script>

import {settings} from '@/components/Data'

import PermitMxins from '@/mixins/PermitMixins'

export default {
  mixins: [PermitMxins],

  props: {
    siteId: {
      type: Number,
      required: true
    },

    rowData: {
      type: Object,
      required: true
    },

    stepData: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    stepData: function (data) {
      this.stepData = data
    }
  },

  methods: {
    completedDate (date, toggle) {
      if (!date) {
        toggle = true
      } else {
        toggle = false
      }
    },

    completedToggle (date, toggle) {
      if (!toggle) {
        date = new Date()
      } else {
        date = null
      }
      console.log('completedToggle', date, toggle)
    },

    success (response) {
      this.dis = true
    },


    fail (response) {
      this.dis = true
    },


    onSave () {
      /*
      this.ticket.opened = this.formatDateTimeSql(this.ticket.opened)
      this.ticket.target = this.formatDateTimeSql(this.ticket.target)
      this.ticket.completedDate = this.formatDateTimeSql(this.ticket.completedDate)

      this.ticket.schedStart = this.formatDateTimeSql(this.ticket.schedStart)
      this.ticket.schedNext = this.formatDateTimeSql(this.ticket.schedNext)
      this.ticket.schedLast = this.formatDateTimeSql(this.ticket.schedLast)
      this.ticket.schedEnd = this.formatDateTimeSql(this.ticket.schedEnd)
      */

      if (!this.step4.organisation_id) {
//        console.log('step4', this.step4, 'id', this.step4.id, 'org. id', this.step4.organisation_id, 'xolas', this.getStore().xolasClient.id)
        this.step4.organisation_id =  Number(this.getStore().xolasClient.id)
      }

      this.saveForm(this, '/step', this.step.id, this.step,
        this.step.name,
        this.success,
        this.fail)

    },

    onCancel () {
      this.dis = true
    },

    onEdit () {
      this.dis = false
    },

  },


  data () {
    return {
      dis: this.disabled,
      actionData: this.rowData,
      step: this.stepData,
      step4: this.stepData.state,
      dateFormat: settings.selectDateFormat,
      width: '12px',
      status: [
        {type: 'Pending'},
        {type: 'Rejected'},
        {type: 'Approved'}
      ]
    } // return
  } // data
}

</script>



// WEBPACK FOOTER //
// ProgressStep4.vue?56a99cbe